/**
 *
 * CollaboratorsImport
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { Link } from "react-router-dom"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import ImportScreen from "components/ImportScreen"
import EmptyButton from "components/EmptyButton"
import reducer from "./reducer"
import saga from "./saga"

import { makeSelectIsDownloading, makeSelectIsUploading } from "./selectors"
import {
  getTemplateCollaboratorsWatcher,
  uploadTemplateCollaboratorsWatcher,
  getTemplateCeasedWatcher,
  uploadTemplateCeasedWatcher,
  getTemplateDivisionsAssignmentWatcher,
  uploadTemplateDivisionsAssignmentWatcher,
  getTemplateTeamsWatcher,
  uploadTemplateTeamsWatcher,
} from "./actions"

// import Loader from 'components/Loader';
import collaboratorsSvg from "../../images/collaborators.svg"
import ceasedSvg from "../../images/ceased.svg"
import { LeftOutlined } from "@ant-design/icons"

class CollaboratorsImport extends React.Component {
  state = { loadScreen: "" }

  UNSAFE_componentWillMount = () => {
    const {
      location: { search },
    } = this.props
    this.setState({ loadScreen: search.split("=")[1] })
  }

  fileSelectedHandlerCeased = (event) => {
    event.preventDefault()
    const fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])
    this.props.uploadTemplateCeasedWatcher(fd)
    this.fileInputCeased.value = ""
  }

  fileSelectHandlerDivisionsAssignment = (event) => {
    event.preventDefault()
    const fd = new FormData
    fd.append("uploaded_file", event.target.files[0])
    this.props.uploadTemplateDivisionsAssignment(fd)
    this.fileInputDivisionsAssignment.value = ""
  }
  
  fileSelectedHandlerTeams = (event) => {
    event.preventDefault()
    const fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])
    this.props.uploadTemplateTeamsWatcher(fd)
    this.fileInputTeams.value = ""
  }

  fileSelectedHandler = (event) => {
    event.preventDefault()
    const fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])
    this.props.uploadTemplateCollaborators(fd)
    this.fileInput.value = ""
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Organización - Colaboradores</title>
          <meta
            name="description"
            content="Description of CollaboratorsImport"
          />
        </Helmet>
        <div style={{ padding: "32px 64px" }}>
          <Link
            style={{
              display: "flex",
              alignItems: "center",
            }}
            to="/organization#collaborators">
            <LeftOutlined /> Colaboradores
          </Link>
        </div>
        {["teams"].includes(this.state.loadScreen) && (
          <ImportScreen
            image={collaboratorsSvg}
            title="Carga líderes"
            description={`
              Carga la información de los líderes que se encuentran dentro de tu organización. Estos 
              <br/>podrán convertirse en usuarios desde la sección Panel de Control - Gestión de Usuarios.
            `}
            secondPoint="Llena los campos con la información de tus líderes."
            thirdPoint="Importa el Excel con la información de tus líderes.">
            <EmptyButton
              size="large"
              label="Descargar plantilla"
              loading={this.props.isDownloading}
              onClick={() => this.props.getTemplateTeams(true)}
            />
            <EmptyButton
              size="large"
              onClick={() => this.fileInputTeams.click()}
              loading={this.props.isUploading}
              label="Importar líderes"
              style={{ marginLeft: "2rem" }}
            />
            <input
              style={{ display: "none" }}
              type="file"
              id="import"
              onChange={this.fileSelectedHandlerTeams}
              ref={(fileInput) => (this.fileInputTeams = fileInput)}
            />
          </ImportScreen>
        )}
        {["collaborators", ""].includes(this.state.loadScreen) && (
          <ImportScreen
            image={collaboratorsSvg}
            title="Carga colaboradores"
            description={`
              Carga la información de los <span>colaboradores</span> que se
              encuentran dentro de tu organización para
              <br/>
              que se conviertan en usuarios de la plataforma.
            `}
            secondPoint="Llena los campos con la información de tus colaboradores."
            thirdPoint="Importa el Excel con la información de tus colaboradores.">
            <EmptyButton
              size="large"
              label="Descargar plantilla"
              loading={this.props.isDownloading}
              onClick={() => this.props.getTemplateCollaborators(true)}
            />
            <EmptyButton
              size="large"
              onClick={() => this.fileInput.click()}
              loading={this.props.isUploading}
              label="Importar colaboradores"
              style={{ marginLeft: "2rem" }}
            />
            <input
              style={{ display: "none" }}
              type="file"
              id="import"
              onChange={this.fileSelectedHandler}
              ref={(fileInput) => (this.fileInput = fileInput)}
            />
          </ImportScreen>
        )}
        {this.state.loadScreen === "ceased" && (
          <ImportScreen
            image={ceasedSvg}
            title="Carga cesados"
            description={`
              Carga la información de los colaboradores que ya no se encuentran dentro de la organización.
              <br/>
              Para hacerlo, únicamente deberás listar los DNI.
            `}
            secondPoint="Llena los campos con los DNI de los colaboradores a cesar."
            thirdPoint="Importa el Excel con la información respectiva.">
            <EmptyButton
              size="large"
              label="Descargar plantilla"
              loading={this.props.isDownloading}
              onClick={() => this.props.getTemplateCeasedWatcher(true)}
            />
            <EmptyButton
              size="large"
              onClick={() => this.fileInputCeased.click()}
              loading={this.props.isUploading}
              label="Importar cesados"
              style={{ marginLeft: "2rem" }}
            />
            <input
              style={{ display: "none" }}
              type="file"
              id="import"
              onChange={this.fileSelectedHandlerCeased}
              ref={(fileInputCeased) =>
                (this.fileInputCeased = fileInputCeased)
              }
            />
          </ImportScreen>
        )}
        {this.state.loadScreen === "divisions-assignment" && (
          <ImportScreen
            image={collaboratorsSvg}
            type="divisions-assignment"
            title="Asignar divisiones a colaboradores"
            description={`Carga las divisiones de los colaboradores que se encuentran dentro de tu organización.`}
            secondPoint="Llena los campos con las divisiones de tus colaboradores."
            thirdPoint="Importa el Excel con las divisiones de tus colaboradores.">              
            <EmptyButton
              size="large"
              label="Descargar plantilla"
              loading={this.props.isDownloading}
              onClick={() => this.props.getTemplateDivisionsAssignment(true)}
            />
            <EmptyButton
              size="large"
              onClick={() => this.fileInputDivisionsAssignment.click()}
              loading={this.props.isUploading}
              label="Importar asignación de divisiones"
              style={{ marginLeft: "2rem" }}
            />
            <input
              style={{ display: "none" }}
              type="file"
              id="import"
              onChange={this.fileSelectHandlerDivisionsAssignment}
              ref={(fileInputDivisionsAssignment) =>
                (this.fileInputDivisionsAssignment = fileInputDivisionsAssignment)
              }
            />
          </ImportScreen>
        )}
      </React.Fragment>
    )
  }
}

CollaboratorsImport.propTypes = {
  getTemplateCollaborators: PropTypes.func.isRequired,
  uploadTemplateCollaborators: PropTypes.func.isRequired,
  getTemplateCeasedWatcher: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  isDownloading: makeSelectIsDownloading(),
  isUploading: makeSelectIsUploading(),
})

function mapDispatchToProps(dispatch) {
  return {
    getTemplateCollaborators: (params) =>
      dispatch(getTemplateCollaboratorsWatcher(params)),
    getTemplateTeams: (params) =>
      dispatch(getTemplateTeamsWatcher(params)),
    uploadTemplateCollaborators: (params) =>
      dispatch(uploadTemplateCollaboratorsWatcher(params)),
    getTemplateCeasedWatcher: (params) =>
      dispatch(getTemplateCeasedWatcher(params)),
    uploadTemplateCeasedWatcher: (params) =>
      dispatch(uploadTemplateCeasedWatcher(params)),
    getTemplateDivisionsAssignment: (params) => dispatch(getTemplateDivisionsAssignmentWatcher(params)),
    uploadTemplateDivisionsAssignment: (params) => dispatch(uploadTemplateDivisionsAssignmentWatcher(params)),
    uploadTemplateTeamsWatcher: (params) => dispatch(uploadTemplateTeamsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "collaboratorsImport", reducer })
const withSaga = injectSaga({ key: "collaboratorsImport", saga })

export default compose(withReducer, withSaga, withConnect)(CollaboratorsImport)
